import React from 'react';
import type { MenuDayForDateResponse, MenuDayItemDto } from '@core/interfaces/api';
import { MealTemplate } from './menu-print-templates';

type MealType = 'breakfast' | 'lunch' | 'dinner';

interface MenuPrintPageProps {
  mealType: MealType;
  menuData: MenuDayForDateResponse;
  communityName: string;
  date: string;
  showDate: boolean;
  bugImageUrl: string | null;
  textAlign?: 'left' | 'center' | 'right';
}

export function MenuPrintPage({
  mealType,
  menuData,
  communityName,
  date,
  showDate,
  bugImageUrl,
  textAlign,
}: MenuPrintPageProps) {
  const day = menuData.day;
  const alwaysAvailable = menuData.alwaysAvailable;

  const mealItems: Record<MealType, MenuDayItemDto[] | undefined> = {
    breakfast: day.menuData.BreakfastItems,
    lunch: day.menuData.LunchItems,
    dinner: day.menuData.DinnerItems,
  };

  const sections = [
    { title: mealType, items: mealItems[mealType] ?? [] },
  ];

  return (
    <MealTemplate
      communityName={communityName}
      date={date}
      showDate={showDate}
      bugImageUrl={bugImageUrl}
      sections={sections}
      alwaysAvailable={alwaysAvailable}
      textAlign={textAlign}
    />
  );
}
